module.exports = __webpack_public_path__ + "img/home-footer-01.484584cf.png";